module.exports = __webpack_public_path__ + "static/img/whatsapp.4fd2c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp.png
// module id = 645
// module chunks = 3